import React from "react";
import { Box, Typography, Select, MenuItem, Pagination, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useThemeContext } from "../../context/ThemeContext";

const CustomPaging = ({ itemsPerPage, setItemsPerPage, page, setPage, totalItems }) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === "dark";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));   // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600-900px

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMobile ? "center" : "space-between",
        alignItems: "center",
        mt: 2,
        flexWrap: "wrap",
        gap: 2,
        background: isDarkMode ? "#333" : "white",
        color: isDarkMode ? "#fff" : "#000",
        p: isMobile ? 1 : 2,
        borderTop: "1px solid #ddd",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {/* Left controls */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? 1 : 3,
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: isMobile ? "12px" : "14px" }}>Show:</Typography>
          <Select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(e.target.value)}
            size={isMobile ? "small" : "medium"}
            sx={{
              minWidth: isMobile ? "60px" : "80px",
              background: isDarkMode ? "#444" : "#fff",
              color: isDarkMode ? "#fff" : "#000",
              fontSize: isMobile ? "12px" : "14px",
            }}
          >
            {[5, 10, 15, 20, 50].map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {!isMobile && (
          <Typography sx={{ whiteSpace: "nowrap", fontSize: "14px" }}>
            Showing {(page - 1) * itemsPerPage + 1} - {Math.min(page * itemsPerPage, totalItems)} of {totalItems}
          </Typography>
        )}
      </Box>

      {/* Pagination */}
      <Pagination
        count={Math.ceil(totalItems / itemsPerPage)}
        page={page}
        onChange={(event, value) => setPage(value)}
        color="primary"
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 2}
      />

      {/* Text dưới mobile */}
      {isMobile && (
        <Typography sx={{ fontSize: "12px", mt: 1 }}>
          {page}/{Math.ceil(totalItems / itemsPerPage)} pages
        </Typography>
      )}
    </Box>
  );
};

export default CustomPaging;
